

import VesselMonitoringBays from '@/view/pages/stowageinstruction/components/VesselMonitoringBay/VesselMonitoringBays.vue'

export default {
  components: {
    VesselMonitoringBays
  },
  props: {
    vesselHatch: {
    },
    minDeckTiersNo:{default: 0},
    minHoldTiersNo:{default: 0},
  },
  computed:{
    
  },
  mounted() {
  }
}
